import { HttpMethod } from './types'
import { Performer, type XRequestConfig } from './performer'

export type ResosurceMetodConfig = {
  request: XRequestConfig['payload'] | void
  response: any
  dtoRequest?: any
  dtoResponse?: any
}

export type ResourceConfig = {
  list?: ResosurceMetodConfig
  get?: ResosurceMetodConfig
  create?: ResosurceMetodConfig
  update?: ResosurceMetodConfig
  delete?: ResosurceMetodConfig
}

export class ListResource<ResourceReq extends XRequestConfig, ResourceResp> extends Performer<
  ResourceReq,
  ResourceResp
> {
  protected method = HttpMethod.GET
  protected url
  constructor(
    entityName: string,
    protected responseTransformer: (p: any) => any = (x) => x
  ) {
    super()
    this.url = `/${entityName}`
  }
}

export class GetResource<ResourceReq extends XRequestConfig, ResourceResp> extends Performer<
  ResourceReq,
  ResourceResp
> {
  protected method = HttpMethod.GET
  protected url
  constructor(
    entityName: string,
    protected responseTransformer: (p: any) => any = (x) => x
  ) {
    super()
    this.url = `/${entityName}/{id}`
  }
}

export class CreateResource<ResourceReq extends XRequestConfig, ResourceResp> extends Performer<
  ResourceReq,
  ResourceResp
> {
  protected method = HttpMethod.POST
  protected url
  constructor(
    entityName: string,
    protected requestTransformer: (p: any) => any = (x) => x,
    protected responseTransformer: (p: any) => any = (x) => x
  ) {
    super()
    this.url = `/${entityName}/{id}`
  }
}

export class UpdateResource<ResourceReq extends XRequestConfig, ResourceResp> extends Performer<
  ResourceReq,
  ResourceResp
> {
  protected method = HttpMethod.PATCH
  protected url
  constructor(
    entityName: string,
    protected requestTransformer: (p: any) => any = (x) => x,
    protected responseTransformer: (p: any) => any = (x) => x
  ) {
    super()
    this.url = `/${entityName}/{id}`
  }
}

export class DeleteResource<ResourceReq extends XRequestConfig, ResourceResp> extends Performer<
  ResourceReq,
  ResourceResp
> {
  protected method = HttpMethod.DELETE
  protected url
  constructor(entityName: string) {
    super()
    this.url = `/${entityName}/{id}`
  }
}
